import './style.scss';

import Swiper from 'swiper/bundle';

import 'swiper/css/bundle';

// eslint-disable-next-line no-unused-vars
const photoSlider = new Swiper('.faq-slider', {
  slidesPerView: "auto",
  pagination: {
    el: '.faq-slider-group__inner .swiper-pagination',
    clickable: true,
  },
});